module.exports = __webpack_public_path__ + "img/bryant-bank-logo.76c97bd7.jpg";